// extracted by mini-css-extract-plugin
export default {"root":"heXmRJOYH8vL59OolDpC","author":"vJbG7fFcjtAEc0QIREuK","name":"fUspM1Px3NR3sintFr2E"};